// extracted by mini-css-extract-plugin
export default {"count":"Bookmark_count__Dk5jB","active":"Bookmark_active__Gl3d0"};